import { SortDescriptor } from "react-aria-components";

import { ManagedUser } from "types/generated";

import { SORT_CONFIG, USERS_SORT_KEYS } from "../constants";

export const sortUsers = (items: ManagedUser[], sortDescriptor: SortDescriptor) => {
  if (!sortDescriptor.column) {
    return items;
  }

  const isAscending = sortDescriptor.direction === "ascending";

  return [...items].sort((a, b) => {
    const key = SORT_CONFIG[sortDescriptor.column as USERS_SORT_KEYS];
    const valueA = a[key]?.toLocaleString() ?? "";
    const valueB = b[key]?.toLocaleString() ?? "";

    return isAscending
      ? valueA.localeCompare(valueB, undefined, { numeric: true })
      : valueB.localeCompare(valueA, undefined, { numeric: true });
  });
};
